import { Moment } from "moment";
import { SalesAgent } from "./sales-agent";

export class WpBookingRequestSearchOptions {

    constructor(
        public displayOption: number,
        public name: string,
        public programmeName: string,
        public startDate: Moment | null,
        public endDate: Moment | null,
        public duration: number,
        public agent: SalesAgent
    ){}
}
